import React, { Suspense, useEffect, useState } from 'react'
import { Box, CircularProgress, Container, Fade } from '@mui/material'
import { useSelector } from 'react-redux';
import { getSelectedAccount, setSelectedAccount } from '../../../redux/selectedAccountSlice';
import { getSelectedBuilding, setSelectedBuilding } from '../../../redux/selectedBuildingSlice';
import { getSelectedSubscription, setSelectedSubscription } from '../../../redux/selectedSubscriptionSlice';
import { getAllAccounts } from '../../../redux/allAccountsSlice';

import { useDispatch } from 'react-redux';

import { usePutPauseStateCodeMutation, usePutResumeStateCodeMutation, usePutActivateStateCodeMutation, usePutResetInitializationStateCodeMutation} from '../../../api/subscription-manager/stateCodeApiSlice'
import { useGetJobSpecificationsQuery } from '../../../api/recalc/endpoints/jobSpecificationApiSlice';
import { useGetUnitsByAccountQuery } from '../../../api/recalc/endpoints/unitsApiSlice'
import { useUpdateSubscriptionMutation, useGetSubscriptionsByAccountQuery, useGetSubscriptionsQuery, usePostSubscriptionMutation } from '../../../api/recalc/endpoints/jobSubscriptionApiSlice';
import { useGetGatewaysByAccountQuery } from '../../../api/recalc/endpoints/gatewayApiSlice';
import { useGetBuildingsQuery } from '../../../api/recalc/endpoints/buildingApiSlice';
import { useGetAccountsQuery } from '../../../api/recalc/endpoints/accountsApiSlice';
import { usePostSubscriptionOnBuildingMutation } from '../../../api/recalc/endpoints/buildingApiSlice';

import { Outlet, useNavigate } from 'react-router-dom';

const SubscriptionDataGrid = React.lazy(() =>
    import('remote/SubscriptionDataGrid').catch(() => ({
      default: () => <div>Failed to load</div>,
    }))
  );

const SubscriptionsPage = () => {
  const selectedAccount = useSelector(getSelectedAccount);
  const selectedBuilding = useSelector(getSelectedBuilding);
  const selectedSubscription = useSelector(getSelectedSubscription);
  const allAccounts = useSelector(getAllAccounts);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: units, isLoading: isLoadingUnits } = useGetUnitsByAccountQuery(selectedAccount?.AccountId, { skip: !selectedAccount.AccountId });
  const { data: gateways, isLoading: isLoadingGateways } = useGetGatewaysByAccountQuery(selectedAccount?.AccountId, { skip: !selectedAccount?.AccountId });
  const { data: subscriptions, isLoading: isLoadingSubscriptions } = useGetSubscriptionsByAccountQuery(selectedAccount?.AccountId, { skip: !selectedAccount?.AccountId }); 
  const { data: allSubscriptions, isLoading: isLoadingAllSubscriptions } = useGetSubscriptionsQuery({ skip: selectedAccount?.Name !== 'Administrator' });
  const { data: jobSpecifications } = useGetJobSpecificationsQuery();
  const { data: buildings } = useGetBuildingsQuery();

  const handleSubscriptionRowClicked = (subscription) => {
    // Switch accounts if necessary
    if (selectedAccount.AccountId !== subscription.AccountId) {
      dispatch(setSelectedAccount(allAccounts.find(account => account.AccountId === subscription.AccountId)));
    }

    // Clean the subscription object to avoid circular references
    const { 
      id,
      Account,
      BuildingName, 
      DisplayName, 
      AccountId,
      JobType,
      State,
      DataInput, 
      LatestJobRun,
      AlgorithmInput, 
      UserInput, 
      ...rest } = subscription;
    
    const cleanedSubscription = {
      BuildingName,
      DisplayName,
      AccountId,
      JobType,
      DataInput,
      State,
      LatestJobRun,
      AlgorithmInput,
      UserInput,
      JobSubscriptions: selectedBuilding.JobSubscriptions,
      id,
      // Add any other required fields from the subscription object
      // Make sure to exclude complex properties like functions, components, or Emotion-related properties
    };
    
    dispatch(setSelectedSubscription(cleanedSubscription));
    const encodedSubscriptionName = encodeURIComponent(subscription.DisplayName);
    // Navigate to the building's subscription page
    navigate(`/buildings/${selectedBuilding.Name}/${encodedSubscriptionName}`, { replace: true });
  };

  return (
    <Container maxWidth='xxl'>
        <Suspense fallback={
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh' }}>
                    <CircularProgress />
                </Box>
                }>
            <Fade in={true} timeout={500}>
                <Box>
                <SubscriptionDataGrid 
                    subscriptions={selectedAccount?.Name !== 'Administrator' ? subscriptions : allSubscriptions}
                    buildings={buildings}
                    accounts={allAccounts}
                    context="administrator"
                    handleSubscriptionRowClicked={handleSubscriptionRowClicked} 
                    jobSpecifications={jobSpecifications}
                    units={units}
                    gateways={gateways}
                    height='90vh'
                    //  onSubmit={handleUpdateSubscription}
                    // handleOpen={handleOpen}
                    // isLoading={isLoadingSubscriptions || isLoadingGateways || isLoadingUnits}
                    //  pause={pause}
                    //  resume={resume}
                    //  activate={activate}
                />
                </Box>
            </Fade>
        </Suspense>
    </Container>
  )
}

export default SubscriptionsPage